module.exports = __webpack_public_path__ + "img/9.249c7d38.png";